module.exports = __webpack_public_path__ + "img/google-app.2b5d939a.png";